import type { INotification } from "@bbj-types/notification";
import { WebsocketSendActions } from "@bbj-types/websockets/subscribe";
import { isLogged } from "@root/api/api.tools";
import type { Dispatch, SetStateAction } from "react";
import { WebsocketClient } from "./WebsocketClient";
import { manageGlobalSubscriptions } from "./globalSubscription";

export interface IUseWebsocketProps {
  setNotifications: Dispatch<SetStateAction<INotification[]>>;
}

export const useWebSocket = ({ setNotifications }: IUseWebsocketProps) => {
  const connectWebsocket = (userId: string) => {
    try {
      const wsClient = new WebsocketClient(
        { userId },
        {
          reconnect: { baseDelayMs: 1000, maxDelayMs: 15000, jitterRatio: 0.2 },
          outboxMax: 100,
          shouldConnect: isLogged,
        }
      );
      window.wsClient = wsClient;
      window.wsClient.connect();

      wsClient.setOnOpenHandler(manageGlobalSubscriptions(wsClient, setNotifications, WebsocketSendActions.SUBSCRIBE));
      wsClient.setOnCloseHandler(
        manageGlobalSubscriptions(wsClient, setNotifications, WebsocketSendActions.UNSUBSCRIBE)
      );

      return () => {
        wsClient.disconnect();
        window.wsClient = null;
      };
    } catch (error) {
      console.error(error);
    }
  };

  return { connectWebsocket };
};
